<template>
  <div class="wrapper">
    <div class="content" v-if="!$store.getters['getLoading']">
      <div class="flexCenter">
        <div class="copy">
          <SuccessShared v-if="showSuccess"/>
          <div>
            <Copy />
          </div>
          <span class="underline" v-on:click="copyShareLink()">Copy link</span><span class="noUnderline">&nbsp;to share</span>
        </div>
        <flipbook class="flipbook" :pages="pages" v-slot="flipbook" :loadingImage="setErrorImage">
          <div class="flip-left">
            <i @click="flipbook.flipLeft" class="icon-chevron-left"></i>
          </div>
          <div class="flip-right">
            <i @click="flipbook.flipLeft" class="icon-chevron-left"></i>
          </div>
        </flipbook>

      </div>
    </div>
    <div v-else class="center-loading">
      <img alt="loading" src="/loading.gif" style="max-height: 100px;">
    </div>
  </div>
</template>

<script>
import Flipbook from 'flipbook-vue'
import Copy from "../components/Copy";
import SuccessShared from "../components/SuccessShared";
import FlipNext from "../components/FlipNext";
import FlipPrevious from "../components/FlipPrevious";

export default {
  name: "Preview",
  components: {
    Flipbook,
    Copy,
    SuccessShared,
    FlipNext,
    FlipPrevious
  },
  data() {
    return {
      shareLink: process.env.VUE_APP_HEADLESS_PREVIEW,
      showSuccess: false,
      showNext: true,
      showPrevious: false,
      zoom: 0,
      pageFlip: null,
      pages: [],
      isLinda: false,
      baseUrl: process.env.VUE_APP_BASE_URL,
      imageId: 0
    };
  },
  computed:{
    setErrorImage(){
      if(this.isLinda){
        return `${this.baseUrl}/linda_blank.png?id=${this.imageId}`;
      }
      return `${this.baseUrl}/blank.png?id=${this.imageId}`;
    }
  },
  methods: {
    async createThumbnailUrl(creationId, canvasId, type= "png_fullsize", linda = false) {
      let that = this;
      const randomInt = Math.floor(Math.random() * 1000);

      setInterval(function () {
        that.imageId = Math.floor(Math.random() * 1000);
      }, 1000)

      return `https://s3.eu-west-1.amazonaws.com/php.jilster.nl/${process.env.VUE_APP_STATUS}_magazinepages/${creationId}/${type}/${canvasId}.png?id=${randomInt}`;
    },
    copyShareLink() {
      const el = document.createElement('textarea');
      el.value = this.shareLink + this.$route.params.magazineId;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);

      this.showSuccess = true
      setTimeout(() => {
        this.showSuccess = false
      }, 2000)
    },
    async getDocumentImages() {
      const documents = await this.$store.getters['getCreation'].data.pages;
      this.pages.push(null);
      for (let i = 0; documents.length > i; i++) {
        await this.createThumbnailUrl(documents[i].creation_id, documents[i].id, "png_fullsize", this.isLinda).then((response) => {
          this.pages.push(response);
        })
      }

    }
  },
  async created() {
    await this.$store.dispatch("getCreation", this.$route.params.magazineId);
    if (this.$store.getters['getCreation'].data.canvasVersion === 'linda') {
      this.isLinda = true
    }
    await this.getDocumentImages();
    await this.$store.dispatch('setLoading');
  },
}
</script>

<style>
.flip-left i{
  position: absolute;
  font-size: 40px;
  top: 40%;
  color: #999187;
}

.flipbook {
  margin-top: 10px;
  position: relative;
  width: 100%;
  height: 90vh;
}

.flip-right i{
  position: absolute;
  font-size: 40px;
  top: 40%;
  right: 0;
  transform: scaleX(-1);
  color: #999187;
}

.wrapper {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.content {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: unset;
}

.flexCenter {
  width: 80%;
  height: 80%;
  display: flex;
  flex-direction: column;
}

.copy {
  display: flex;
  flex-direction: row;
  width: 80%;
  justify-content: right;
  align-items: center;
  margin: 0 auto;
  overflow: unset;
  position: relative;
}

.copy svg {
  height: 20px;
  width: 20px;
  margin-right: 4px;
}

.copy .underline {
  color: #fff;
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
}

.copy .noUnderline{
  color: #fff;
  font-weight: normal;
  text-decoration: none;
}

.flipbookWrapper {
  flex: 1;
  max-width: 100%;
  padding: 1rem;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

#page-flip-container {
  max-width: 800px;
  max-height: 600px;
  overflow: auto;
}


#page-flip-container::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}

/* Track */
#page-flip-container::-webkit-scrollbar-track {
  background: #fff;
}

/* Handle */
#page-flip-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 999px;
}

/* Handle on hover */
#page-flip-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.btnFlip {
  height: 40px;
  width: 40px;
  cursor: pointer;
}

.hiddenBtnFlip {
  visibility: hidden;
}

.zoomActions {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.zoomButtons {
  padding: 8px;
  background-color: #fff;
  display: flex;
  flex-direction: row;
}

.zoomButtons i {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  cursor: pointer;
  font-weight: normal !important;
}

.zoomActions p {
  margin: 0 16px;
  color: black !important;
}

</style>
